<template> 
  <AdminTop /> 
</template> 

<script> 
  import AdminTop from '../components/AdminTop'  
  export default { 
    components: { 
      AdminTop 
    } 
  } 
</script> 